import type { ThunkDispatchType } from '../../redux/types';

import { API, ResponseStatus } from 'app/api';
import { getBrowserTabId } from 'app/lib/browserTabId';
import { login, loginAfterRedirect, logout, reLogin } from 'app/redux/actions/auth';

// ---

const AUTH_CHANNEL_STORAGE_KEY = 'auth-channel';
const LOGOUT_MESSAGE = 'LOGOUT_MESSAGE';
const LOGIN_MESSAGE = 'LOGIN_MESSAGE';

// ---

export const initAuthChannel = () => (dispatch: ThunkDispatchType) => {
  window.addEventListener('storage', (event: StorageEvent) => {
    if (!event.key?.startsWith(AUTH_CHANNEL_STORAGE_KEY) || event.newValue === null) {
      return;
    }

    const tabId = event.key.split('__')[1];

    if (isTabInitiatorEvent(tabId)) {
      return;
    }

    switch (event.newValue) {
      case LOGIN_MESSAGE:
        dispatch(reLogin());
        break;

      case LOGOUT_MESSAGE:
        dispatch(logout());
        break;

      default:
        console.error(`authChannel:message: unknown message type ${event.newValue}`);
        break;
    }

    removeAuthChannelFromStorage(event.key);
  });
};

function isTabInitiatorEvent(tabIdFromStorage: string) {
  return getBrowserTabId() === tabIdFromStorage;
}

function getStorageKey() {
  const tabId = getBrowserTabId();

  return `${AUTH_CHANNEL_STORAGE_KEY}__${tabId}`;
}

function removeAuthChannelFromStorage(key: string) {
  localStorage.removeItem(key);
}

function saveAuthDataToStorage(messageType: string) {
  localStorage.setItem(getStorageKey(), messageType);
}

// ---

export const logoutAllTabs = () => async (dispatch: ThunkDispatchType) => {
  await dispatch(logout());

  saveAuthDataToStorage(LOGOUT_MESSAGE);
};

type User = {
  username: string;
  password: string;
  requestId?: string;
  name?: {
    firstName: string;
    middleName?: string;
    lastName: string;
  };
};

// ToDo Необходимо переделать типизацию функции getAsyncThunk и ThunkDispatchType таким образом,
// чтобы можно было использовать result.payload.status и избавиться от использования AnyType.
export const loginAllTabs = (user: User) => async (dispatch: AnyType) => {
  try {
    const result = await dispatch(login(user));
    saveAuthDataToStorage(LOGIN_MESSAGE);

    if (result.payload.status === ResponseStatus.SUCCESS) {
      dispatch(reLogin());

      if (user.name) {
        API.client.clientProfile.savePersonalData(user.name);
      }
    }
  }
  catch (error) {
    console.error('Error occurred during login:', error);
  }
};

export const handleLoginAfterRedirect = (redirectKey: string) => async (dispatch: AnyType) => {
  try {
    const result = await dispatch(loginAfterRedirect({ redirectKey }));

    if (result.payload.status === ResponseStatus.SUCCESS) {
      dispatch(reLogin());
    }
  }
  catch (error) {
    console.error('Error occurred during login with redirectKey:', error);
  }
};
